import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { Room } from '../../model/room';
import { RoomType } from '../../../dwelling-inspection/model/dwelling-inspection-room';

@Component({
    selector: 'app-room-order-sidebar',
    templateUrl: './room-order-sidebar.component.html',
    styleUrls: ['./room-order-sidebar.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class RoomOrderSidebarComponent implements OnChanges {
  @Input() items: Room[] = [];
  @Input() open: boolean;
  @Output() onSave = new EventEmitter<Room[]>();
  @Output() onCancel = new EventEmitter<boolean>();

  reorderedItems: Room[] = [];

  constructor() {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes['open']?.currentValue) {
      this.reorderedItems = [...(this.items ?? [])];
    }
  }

  sidebarSave(): void {
    this.onSave.emit(this.reorderedItems);
    this.sidebarCancel(false);
  }

  sidebarCancel(revert: boolean): void {
    this.onCancel.emit(revert);
  }

  drop(event: CdkDragDrop<Room[]>) {
    moveItemInArray(this.reorderedItems, event.previousIndex, event.currentIndex);
    this.reorderedItems = [...this.reorderedItems];
  }

  getIcons(room: Room) {
    return {
      'balcony-i': room.type === RoomType.Balcony,
      'bedroom-i': room.type === RoomType.Bedroom,
      'bathroom-i': room.type === RoomType.Bathroom,
      'dressing-room-i': room.type === RoomType.DressingRoom,
      'hall-i': room.type === RoomType.Hall,
      'kitchen-i': room.type === RoomType.Kitchen,
      'living-room-i': room.type === RoomType.LivingRoom,
      'room-i': true,
      'toilet-i': room.type === RoomType.Toilet,
      'other-room-i': room.type === RoomType.Other,
    };
  }
}
